import React from "react";
import { useHistory } from "react-router";
import { Box, Grid } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import { Theme } from "@mui/material/styles";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
import Toolbar from "@mui/material/Toolbar";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import MenuIcon from "@mui/icons-material/Menu";
import clsx from "clsx";
import { logOutAction } from "src/app-redux/auth/actions/authActions";
import { useAppDispatch } from "src/app-redux/hooks";
import NatJanWhiteLogo from "src/assets/images/tfg_favicon_white.svg";
import { DRAWER_WIDTH } from "./SideNav";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      zIndex: theme.zIndex.modal + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },

    appBarShift: {
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
      marginLeft: DRAWER_WIDTH,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  })
);

type Props = { open: boolean; toggleDrawer: () => void };

export function Header(props: Props) {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const classes = useStyles();

  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: props.open,
      })}
    >
      <Toolbar>
        <Grid justifyContent="space-between" container>
          <Grid item>
            <Grid container direction="row" justifyContent="flex-start" alignItems="center">
              <Box mt={1} mb={1} my={1}>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={props.toggleDrawer}
                  edge="start"
                  size="large"
                >
                  {props.open ? <ChevronLeftIcon /> : <MenuIcon />}
                </IconButton>
              </Box>
              {!props.open && (
                <Box mt={1} mb={1} my={1}>
                  <img src={NatJanWhiteLogo} alt="logo" width="35" />
                </Box>
              )}
            </Grid>
          </Grid>
          <Grid item>
            <Box mt={1} mb={1} my={1}>
              <IconButton
                color="inherit"
                onClick={async () => {
                  await dispatch(logOutAction());
                  dispatch({ type: "auth/logout" });
                  history.push("/auth/login");
                }}
                size="large"
              >
                <LockOpenIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}
